import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import apiService from "../Services/api.service";
import CustomButton from "./Button";
import { useToast } from "./Toast";


export default function SwapPlanPopup({
  open,
  onClose,
  token,
  subscriptionId,
  otherSubscriptions = [],
}) {
  const Toast = useToast();
  const [targetId, setTargetId] = useState("");
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) {
      setTargetId("");
      setReason("");
    }
  }, [open]);

  const handleSwap = async () => {
    if (!targetId || !reason.trim()) return;

    try {
      setSubmitting(true);
      await apiService.swapSubscriptionPlans(token, {
        subscriptionIdA: subscriptionId,
        subscriptionIdB: targetId,
        reason,
      });
      onClose();
    } catch (error) {
      Toast.error(
        error.response?.data?.message || "Error swapping subscription plans",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: "bold" }}>
        Swap Plan With Another Subscription
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 10, top: 10 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Only the plan (name, price, limits) moves between the two
          subscriptions — their dates stay exactly as they are. Blocked once
          either side already has real scan usage.
        </Typography>

        <TextField
          select
          fullWidth
          label="Swap plan with"
          value={targetId}
          onChange={(e) => setTargetId(e.target.value)}
          sx={{ mb: 2 }}
        >
          {otherSubscriptions.map((sub) => (
            <MenuItem key={sub._id} value={sub._id}>
              {sub.planName} •{" "}
              {new Date(sub.startDate).toLocaleDateString("en-IN")} -{" "}
              {new Date(sub.endDate).toLocaleDateString("en-IN")}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label="Reason"
          required
          fullWidth
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <CustomButton text="Cancel" onClick={onClose} width="120px" />
        <CustomButton
          text="Swap"
          onClick={handleSwap}
          width="150px"
          disabled={!targetId || !reason.trim() || submitting}
        />
      </DialogActions>
    </Dialog>
  );
}
